import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import { Task } from '@mui/icons-material';
import {
  Avatar,
  Paper,
  Stack,
  Typography,
} from '@mui/material';
import { setTimezones } from '../../../../../redux/app/actions';
import { getHorseLocations } from '../../../../../redux/horse/actions';
import { getSchedules } from '../../../../../redux/schedule/actions';
import Tasks from '../../../../task/Tasks';

const SchedulesCardComponent = ({
  id,
  navigate,
  permissions,
}) => {
  const dispatch = useDispatch();
  const [sortModel] = React.useState([
    {
      field: 'startDate',
      sort: 'desc',
    },
  ]);

  // Redux state
  const currentHorseLodging = useSelector((state) => state.horse.currentHorseLodging);

  React.useEffect(() => {
    dispatch(getHorseLocations(id, 0, 5, sortModel.map((s) => `&sort=${s.field},${s.sort}`))).then((horseLocations) => {
      if (horseLocations.content.length > 0) {
        const now = new Date();
        const sublist = horseLocations.content.filter((l) => new Date(l.startDate) < now
          && (l.endDate === null || new Date(l.endDate) > now));

        // setTimezone for horse current location
        if (sublist.length > 0) {
          dispatch(setTimezones(sublist[0].location.timezone))
        }
      }
    });
  }, [id]);

  // React state
  const [startDate] = React.useState(new Date());
  const [endDate] = React.useState(moment().add(3, 'months').endOf('day').toDate());

  React.useEffect(() => {
    if (currentHorseLodging && currentHorseLodging.pingumTagId) {
      dispatch(getSchedules(startDate, endDate, [currentHorseLodging.pingumTagId]));
    }
  }, [startDate, endDate, currentHorseLodging]);

  return (
    <Paper
      sx={{ borderRadius: 3 }}
    >
      <Stack
        direction={{
          xs: 'column',
          sm: 'row',
        }}
        spacing={2}
        alignItems={{
          xs: 'flex-start',
          sm: 'center',
        }}
        justifyContent="space-between"
        sx={{
          mb: 2,
          px: 2,
          pt: 2,
        }}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Avatar><Task /></Avatar>
          <Typography variant="h5" sx={{ fontWeight: 600 }}>
            Task History
          </Typography>
        </Stack>
      </Stack>

      <Tasks
        navigate={navigate}
        initialFilter={{ tagConditions: [[parseInt(currentHorseLodging.pingumTagId, 10)]] }}
        permissions={permissions}
        hideNav
        callbackOnAdd={() => { dispatch(getSchedules(startDate, endDate, [currentHorseLodging.pingumTagId])); }}
      />
    </Paper>
  );
};

SchedulesCardComponent.propTypes = {
  id: PropTypes.any.isRequired,
  navigate: PropTypes.func.isRequired,
  permissions: PropTypes.object.isRequired,
};

export default SchedulesCardComponent;
